import React from "react";
import { Toast } from "react-bootstrap";
import PropTypes from "prop-types";
const ToastNotification = ({ showSuccessToast, showErrorToast, message }) => {
  return (
    <>
      {/* Success Toast */}
      <Toast
        show={showSuccessToast}
        onClose={() => {}}
        className="colored-toast bg-success-transparent" //
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
      >
        <Toast.Header className="bg-success ">
          <strong className="me-auto">Success</strong>
        </Toast.Header>
        <Toast.Body className="toast-body">{message}</Toast.Body>
      </Toast>

      {/* Error Toast */}
      <Toast
        show={showErrorToast}
        onClose={() => {}}
        className="colored-toast bg-danger-transparent" //  bg-danger-transparent
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
      >
        <Toast.Header className="bg-danger text-fixed-white">
          <strong className="me-auto">Failed</strong>
        </Toast.Header>
        <Toast.Body className="toast-body">{message}</Toast.Body>
      </Toast>
    </>
  );
};

export default ToastNotification;

ToastNotification.propTypes = {
  showSuccessToast: PropTypes.bool.isRequired,
  showErrorToast: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
};

// ToastNotification.defaultProps = {
//   showSuccessToast: false,
//   showErrorToast: false,
//   message: "",
// };
